<template>
    <!-- 医生管理 -->
    <div id="docAdmin" class="sys-page">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item to="/hospManage">医院管理</el-breadcrumb-item>
                <el-breadcrumb-item to="/hospDetail">医院信息</el-breadcrumb-item>
                <el-breadcrumb-item>医生管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="tableBox">
            <div class="btn">
                <el-button type="primary" @click="add()">添加医生</el-button>
            </div>
            <el-table :data="tableData.body" style="width: 98%;margin:0 auto">
                <el-table-column header-align=center align="center" type=index label="序号" width="50"></el-table-column>
                <el-table-column header-align=center align="center" prop="userName" label="姓名"></el-table-column>
                <el-table-column header-align=center align="center" prop="userTel" label="手机号"></el-table-column>
                <el-table-column header-align=center align="center" prop="proRank" label="职称"></el-table-column>
                <el-table-column header-align=center align="center" prop="deptName" label="所属科室"></el-table-column>
                <el-table-column header-align=center align="center" prop="userStatus" label="是否启用">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.userStatus"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949" 
                                    active-value="01" 
                                    inactive-value="02"
                                    @change="change(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column align =center label="操作" header-align=center width="240">
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="editMsg(scope.row)">编辑</el-button>
                        <el-button type="primary" size="small" @click="reset(scope.row)">重置密码</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination  :page-size="20" :page-count="5" layout="total, prev, pager, next" :total="tableData.count" @current-change='currentChange' style="text-align:right"></el-pagination>
            </div>
        </div>
        <el-dialog title="添加医生" :visible.sync="addNew" width="600px" center @close="closeDialog()">
            <el-form ref="newDoc" :model="newDoc" :rules="newDocRules" label-width="110px">
                <el-form-item label="医生姓名" prop="userName">
                    <el-input type="text" placeholder="请输入医生姓名" v-model="newDoc.userName"></el-input>
                </el-form-item>
                <el-form-item label="医生性别" prop="userGender">
                    <el-radio-group v-model="newDoc.userGender">
                        <el-radio label="M">男</el-radio>
                        <el-radio label="F">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="医生职称" prop="proRank">
                    <el-input type="text" placeholder="请输入医生职称" v-model="newDoc.proRank"></el-input>
                </el-form-item>
                <el-form-item label="所属科室" prop="deptName">
                    <el-input type="text" placeholder="请输入医生所属科室" v-model="newDoc.deptName"></el-input>
                </el-form-item>
                <el-form-item label="角色(可多选)" prop="roleId">
                    <el-checkbox-group v-model="newDoc.roleId">
                        <el-checkbox v-for="item in roleList" :label="item.roleId" :key="item.roleId">{{item.roleName}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="手机号" prop="userTel">
                    <el-input type="text" placeholder="该手机号将作为用户名登录使用" v-model="newDoc.userTel" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" placeholder="请输入密码,不少于六位" v-model="newDoc.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="rePassword">
                    <el-input type="password" placeholder="请再次输入密码" v-model="newDoc.rePassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item style="text-align:right;">
                    <el-button type="primary" @click="submit()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="编辑医生" :visible.sync="editNew" width="600px" center>
            <el-form ref="editDoc" :model="editDoc" :rules="editDocRules" label-width="110px">
                <el-form-item label="医生姓名">
                    <el-input type="text" disabled v-model="editDoc.userName"></el-input>
                </el-form-item>
                <el-form-item label="医生性别">
                    <el-radio-group disabled v-model="editDoc.userGender">
                        <el-radio label="M">男</el-radio>
                        <el-radio label="F">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="医生职称" prop="proRank">
                    <el-input type="text" placeholder="请输入医生职称" v-model="editDoc.proRank"></el-input>
                </el-form-item>
                <el-form-item label="所属科室" prop="deptName">
                    <el-input type="text" placeholder="请输入医生所属科室" v-model="editDoc.deptName"></el-input>
                </el-form-item>
                <el-form-item label="角色(可多选)" prop="roleId">
                    <el-checkbox-group v-model="editDoc.roleId">
                        <el-checkbox v-for="item in roleList" :label="item.roleId" :key="item.roleId">{{item.roleName}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input type="text" disabled v-model="editDoc.userTel" placeholder="该手机号将作为用户名登录使用,提交后不可修改"></el-input>
                </el-form-item>
                <el-form-item style="text-align:right;">
                    <el-button type="primary" @click="save()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {isvalidPhone} from '@/service/common'
import { Loading } from 'element-ui';
//定义一个全局的变量，手机号验证
var validPhone=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入电话号码'))
    }else  if (!isvalidPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
var validatePass=(rule, value, callback)=>{
    if (value === '') {
        callback(new Error('请输入密码'));
    }
    else if(value.length<6){
        callback(new Error('密码不能少于6位'));
    }
    else{
        callback()
    }
}
export default {
    name:'docAdmin',
    data(){
        return{
            hospMsg:'',
            roleList:[],
            deptList:[],
            proList:[],
            tableData:{
                count:10,
                body:[]
            },
            addNew:false,
            newDoc:{
                userName:'',//姓名
                userGender:'',//性别
                userTel:'',//电话
                idCard:'',
                proRank:'',//职称
                deptName:'',//科室id
                hospId:'',
                roleId:[],//权限
                password:'',//密码
                rePassword:'',//确认密码
            },
            newDocRules:{
                userName:[{ required: true, message: '请输入医生姓名', trigger: 'blur' }],
                userGender:[{ required: true, message: '请选择医生性别', trigger: 'change' }],
                userTel:[{ required: true, trigger: 'blur', validator: validPhone },
                        { required: true, message: '请输入电话号', trigger: 'blur' },
                        { min: 7, max: 11, message: '请输入正确的电话', trigger: 'blur' }],
                proRank:[{ required: true, message: '请输入医生职称', trigger: 'blur' }],
                deptName:[{ required: true, message: '请输入所属科室', trigger: 'blur' }],
                roleId:[{ required: true, message: '请选择医生角色', trigger: 'change' }],
                password:[{ required: true, validator: validatePass,trigger: 'blur' }],
                rePassword:[{ required: true, validator: validatePass, trigger: 'blur' }]
            },
            editNew:false,
            editDoc:{},
            editDocRules:{
                proRank:[{ required: true, message: '请输入医生职称', trigger: 'change' }],
                deptName:[{ required: true, message: '请输入所属科室', trigger: 'blur' }],
                roleId:[{ required: true, message: '请选择医生角色', trigger: 'change' }]
            },
            loadingInstance:''
        }
    },
    mounted(){
        this.hospMsg=this.$common.getStorage('hospMsg');
        this.getDocList(1);
        this.getRoleList();
    },
    methods:{
        //医生的启用、禁用
        change(row){
            //禁用医生
            if(row.userStatus=='02'){
                this.$ajax.post(this.$domain.updateUserInfo,{
                    userId:row.userId,
                    userStatus:'02'
                })
                .then(ret=>{
                    this.$common.getConsole('docAdmin.vue--禁用医生',ret.data)
                    if(ret.data.code==200){
                        this.$message.success('医生禁用成功!')
                    }
                    else{
                        this.$message.error(ret.data.message);
                        row.userStatus='01'
                    }
                })
            }

            //启用医生
            else{
                this.$ajax.post(this.$domain.updateUserInfo,{
                    userId:row.userId,
                    userStatus:'01'
                })
                .then(ret=>{
                    this.$common.getConsole('docAdmin.vue--启用医生',ret.data)
                    if(ret.data.code==200){
                        this.$message.success('医生启用成功!')
                    }
                    else{
                        this.$message.error(ret.data.message);
                        row.userStatus='02'
                    }
                })
            }
        },
        //分页
        currentChange(val){
            this.getDocList(val);
        },
        //获得医生列表
        getDocList(page){
            this.$ajax.post(this.$domain.queryUserFromHosp,{
                hospId:this.hospMsg.hospId,
                page:page,
                rows:10
            })
            .then(ret=>{
                this.$common.getConsole('docAdmin.vue--获得医生列表',ret.data)
                if(ret.data.code==200){
                    this.tableData.body=ret.data.data.data;
                    this.tableData.count=ret.data.data.count;
                }
                else if(ret.data.code=='502'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else if(ret.data.code!='201'){
                    this.$message.error(ret.data.message);
                }
            })
        },
        add(){
            this.addNew=true;
            this.newDoc={
                userName:'',//姓名
                userGender:'',//性别
                userTel:'',//电话
                idCard:'',
                proRank:'',//职称
                deptName:'',//科室id
                hospId:'',
                roleId:[],//权限
                password:'',//密码
                rePassword:'',//确认密码
            }
        },
        //添加医生
        submit(){
            this.loadingInstance=Loading.service({
                text:'医生创建中，请稍后',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$refs['newDoc'].validate((valid) => {
                if (valid) {
                    if(this.newDoc.password.length<6){
                        this.$message.error('密码不得少于六位！');
                        this.loadingInstance.close();
                        return;
                    }
                    if(this.newDoc.password!=this.newDoc.rePassword){
                        this.loadingInstance.close();
                        this.$message.error('两次密码输入不一致');
                        return;
                    }
                    let obj={
                        userName:this.newDoc.userName,//姓名
                        userGender:this.newDoc.userGender,//性别
                        userTel:this.newDoc.userTel,//电话
                        proRank:this.newDoc.proRank,//职称
                        deptName:this.newDoc.deptName,//科室id
                        hospId:this.hospMsg.hospId,
                        idCard:this.newDoc.idCard,
                        roleId:this.newDoc.roleId,//权限
                        password:this.$common.pwd99(this.newDoc.password),//密码
                    }
                    this.$ajax.post(this.$domain.openAccount,obj)
                    .then(ret=>{
                        this.loadingInstance.close();
                        this.$common.getConsole('docAdmin.vue--添加医生',ret.data)
                        if(ret.data.code==200){
                            this.$message.success('添加成功');
                            this.newDoc={
                                userName:'',//姓名
                                userGender:'',//性别
                                userTel:'',//电话
                                proRank:'',//职称
                                deptName:'',//科室id
                                hospId:'',
                                roleId:[],//权限
                                password:'',//密码
                                rePassword:'',//确认密码
                            };
                            this.addNew=false;
                            this.getDocList(1);
                        }
                        else if(ret.data.code=='502'){
                            this.$message.error('登录失效，请重新登录!')
                            this.$router.push({path:'/login'});
                        }
                        else if(ret.data.code=='202'){
                            this.$message.error("手机号已存在，请检查手机号！");
                        }
                    })
                } else {
                    this.loadingInstance.close();
                    this.$message.error('表单信息不完整!')
                    return false;
                }
            })
                    
        },
        editMsg(row){
            this.$ajax.post(this.$domain.queryUserInfo,{
                userId:row.userId
            })
            .then(ret=>{
                this.$common.getConsole('docAdmin.vue--查询医生信息',ret.data)
                if(ret.data.code==200){
                    this.editDoc=ret.data.data;
                    this.editNew=true;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
            })
        },
        //修改保存医生信息
        save(){
            this.loadingInstance=Loading.service({
                text:'医生信息保存中，请稍后',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$refs['editDoc'].validate((valid) => {
                if (valid) {
                    this.$ajax.post(this.$domain.updateUserInfo,this.editDoc)
                    .then(ret=>{
                        this.loadingInstance.close();
                        this.$common.getConsole('docAdmin.vue--修改保存医生信息',ret.data)
                        if(ret.data.code==200){
                            this.$message.success('修改成功');
                            this.editDoc={};
                            this.editNew=false;
                            this.getDocList(1);
                        }
                        else if(ret.data.code=='502'){
                            this.$message.error('登录失效，请重新登录!')
                            this.$router.push({path:'/login'});
                        }
                        else if(ret.data.code!='201'){
                            this.$message.error(ret.data.message);
                        }
                    })
                } else {
                    this.loadingInstance.close();
                    this.$message.error('表单信息不完整!')
                    return false;
                }
            })
                    
        },
        //重置密码
        reset(row){
            this.$prompt('', '请输入新密码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputType:'password'
            }).then(({ value }) => {
                if(value.length<6){
                    this.$message.error('密码不得少于六位！');
                    return;
                }
                this.$ajax.post(this.$domain.resetAdminPwd,{
                    userId:row.userId,
                    password:this.$common.pwd99(value)
                })
                .then(ret=>{
                    this.$common.getConsole('docAdmin.vue--重置密码',ret.data)
                    if(ret.data.code==200){
                        this.$message.success('重置密码成功')
                    }
                    else if(ret.data.code=='502'){
                        this.$message.error('登录失效，请重新登录!')
                        this.$router.push({path:'/login'});
                    }
                })
            }).catch(() => {
                       
            });
            
        },
        getRoleList(){
            this.$ajax.post(this.$domain.queryRoleList,{})
            .then(ret=>{
                this.$common.getConsole('docAdmin.vue--查询公共角色',ret.data)
                if(ret.data.code==200){
                    this.roleList=ret.data.data;
                }
                else if(ret.data.code=='502'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
            })
        },
        //关闭弹框
        closeDialog(){
            this.newDoc={
                userName:'',//姓名
                userGender:'',//性别
                userTel:'',//电话
                idCard:'',
                proRank:'',//职称
                deptName:'',//科室id
                hospId:'',
                roleId:[],//权限
                password:'',//密码
                rePassword:'',//确认密码
            }
            //去掉验证
            this.$refs['newDoc'].resetFields();
        }
    }
}
</script>

<style lang="scss" scoped>
#docAdmin{
    width:100%;
    max-width:1600px;
    min-width:1000px;
    margin:auto;
    padding:0 10%;
    box-sizing: border-box;
    text-align: center;
    .breadcrumb{
        width:100%;
        margin:20px auto;
        box-sizing: border-box;
    }
    .title{
        font-size: 24px;
        margin-top:30px;
        text-align: left;
        color:#0659C5;
        font-weight: bold;
        padding:10px 10px;
        border-bottom:1px solid #0659C5;
    }
    .tableBox{
        margin-top:20px;
        .btn{
            margin-bottom:10px;
            text-align: right;
            padding:10px;
            box-sizing: border-box;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/docAdmin.vue